import { render, staticRenderFns } from "./Mares.vue?vue&type=template&id=1001d431&"
import script from "./Mares.vue?vue&type=script&lang=js&"
export * from "./Mares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports